import React, { Fragment } from 'react'
import { connect } from 'react-redux'

import PageLoader from '../../../UI/PageLoader/PageLoader'
import AxiosLoader from '../../../UI/AxiosLoader/AxiosLoader'

const ReduxLoader = ({ auth, organization, audience, account, campaign }) => {
  return (
    <Fragment>
      {auth.loading && <PageLoader />}
      {(organization.updating ||
        audience.updating ||
        account.updating ||
        campaign.updating) && <AxiosLoader />}
    </Fragment>
  )
}

export default connect((state) => {
  return state
})(ReduxLoader)
